<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <!-- <v-card-title>
          <div class="headline" v-if="newGSTStat">New GST Status</div>
          <div class="headline" v-else>Review GST Status</div>
        </v-card-title> -->
        <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit GST Status </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query GST Status </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newGSTStat" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New GST Status</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-sm>
            <v-layout row>
              <v-flex xs6 v-if="newGSTStat">
                <v-text-field
                  v-model="gstStatForm.gstStat"
                  :label="labels.gstStat"
                  :error-messages="errors.collect('gstStat')"
                  data-vv-name="gstStat"
                  :data-vv-as="labels.gstStat"
                  v-validate="'required|max:1'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.gstStat }}</v-subheader>
                <div class="queryValue">{{ gstStatForm.gstStat }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="gstStatForm.gstStatDesc"
                  :label="labels.gstStatDesc"
                  :error-messages="errors.collect('gstStatDesc')"
                  data-vv-name="gstStatDesc"
                  :data-vv-as="labels.gstStatDesc"
                  v-validate="'required|max:20'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ gstStatForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ gstStatForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout row v-if="!newGSTStat">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ gstStatForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ gstStatForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn class="mr-2" color="error" @click="doCancel">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" v-if="!queryMode" dark class=" mr-2" @click="doSaveGSTStat">
          Save Record
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <template v-if="!newGSTStat">
          <v-divider></v-divider>
          <v-toolbar v-if="!newGSTStat" dense color="grey lighten-3" flat>
            <v-icon>mdi-view-list </v-icon>
            <v-toolbar-title>GST Rate </v-toolbar-title>
          </v-toolbar>
          <v-flex>
            <v-card>
              <v-card-title>
                <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class=" mr-2" @click="doNewGSTRate">
                  New GST Rate
                  <v-icon right>mdi-plus</v-icon>
                </v-btn>
                <v-flex xs12>
                  <message :messages="messages"></message>
                </v-flex>
              </v-card-title>
              <v-flex>
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    v-bind:options.sync="pagination"
                    item-key="name"
                    :loading="loading"
                    :no-data-text="noDataText"
                    :custom-filter="customSearch"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td class="text-xs-left">{{ row.item.effDate }}</td>
                        <td class="text-right">{{ row.item.gstRate }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            review
                            @review="doReviewGSTRate(row.item)"
                            query
                            @query="doQueryGSTRate(row.item)"
                            remove
                            @remove="doDelete(row.item)"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-card>
          </v-flex>
        </template>
      </v-card>
      <v-dialog v-model="reviewGSTRate" width="800px" persistent>
        <v-card :key="reviewGSTRate">
          <v-toolbar v-if="newGSTRate" dense color="grey lighten-3" flat>
            <v-icon>mdi-plus </v-icon>
            <v-toolbar-title>Create New GST Rate </v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="reviewGSTRateMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-pencil </v-icon>
            <v-toolbar-title>Edit GST Rate </v-toolbar-title>
          </v-toolbar>
          <v-toolbar v-if="queryGSTRateMode" dense color="grey lighten-3" flat>
            <v-icon>mdi-magnify </v-icon>
            <v-toolbar-title>Query GST Rate </v-toolbar-title>
          </v-toolbar>
          <!-- <v-card-title>
            <span class="headline">GST Rate</span>
          </v-card-title> -->
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row>
                <v-flex xs6>
                  <cal-picker
                    :label="labels.effDate"
                    v-model="gstRateForm.effDate"
                    :error-messages="errors.has('effDate', 'gstRateForm') ? errors.collect('gstRateForm.effDate') : errors.collect('effDate')"
                    data-vv-name="effDate"
                    :data-vv-as="labels.effDate"
                    data-vv-scope="gstRateForm"
                    v-validate="'required'"
                    :disabled="!newGSTRate"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :readonly="queryGSTRateMode"
                    v-num-mask="{ intScale: 18, decScale: 2 }"
                    :label="labels.gstRate"
                    v-model="gstRateForm.gstRate"
                    :error-messages="errors.collect('gstRateForm.gstRate')"
                    data-vv-name="gstRate"
                    :data-vv-as="labels.gstRate"
                    v-validate="'required|between:0,100'"
                    data-vv-scope="gstRateForm"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                  <div class="queryValue">{{ gstRateForm.createdBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                  <div class="queryValue">{{ gstRateForm.createdDate | formatDate }}</div>
                </v-flex>
              </v-layout>
              <v-layout row v-if="!newGSTRate">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                  <div class="queryValue">{{ gstRateForm.modifiedBy }}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                  <div class="queryValue">{{ gstRateForm.modifiedDate | formatDate }}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" v-if="!queryGSTRateMode" flat @click.native="doSaveGSTRate">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm ref="confirmDelete">
        Are you sure you want to delete the selected GST Rate? ({{ selected.gstStat }}, {{ selected.effDate | formatDate }}, {{ selected.gstRate }})
      </confirm>
      <confirm ref="globalPrompt" :label="promptLabel"></confirm>
    </lazy-div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        gstStat: 'GST Status',
        gstStatDesc: 'Description',
        effDate: 'Effective Date',
        gstRate: 'GST Rate',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      gstStatForm: {
        gstStat: null,
        gstStatDesc: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      headers: [
        { text: 'Effective Date', value: 'effDate' },
        { text: 'GST Rate', value: 'gstRate', align: 'right' },
        { text: '', value: '', sortable: false },
        { text: '', value: '', sortable: false },
        { text: '', value: '', sortable: false },
        TableConst.tableActionHeader
      ],
      gstRateForm: {
        gstStat: null,
        effDate: null,
        gstRate: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      newGSTRate: false,
      reviewGSTRate: false,
      reviewGSTRateMode: false,
      queryGSTRateMode: false,
      selected: {
        gstStat: null,
        effDate: null,
        gstRate: null
      },
      promptLabel: '',
      reviewMode: false,
      queryMode: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newGSTStat) {
        await this.fetchGSTStat()
        this.fetchGSTRate()
      } else {
        this.gstStatForm.gstStat = null
        this.gstStatForm.gstStatDesc = null
        this.gstStatForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.gstStatForm.createdDate = new Date()
      }
    },
    async fetchGSTStat() {
      const apiURI = this.menu.getGSTStat
      if (apiURI) {
        try {
          const expand = {
            gstStat: this.gstStat
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.gstStatForm.gstStat = data.gstStat.gstStat
            this.gstStatForm.gstStatDesc = data.gstStat.gstStatDesc
            this.gstStatForm.createdBy = data.createdBy
            this.gstStatForm.createdDate = data.createdDate
            this.gstStatForm.modifiedBy = data.modifiedBy
            this.gstStatForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchGSTRate() {
      const apiURI = this.menu.getGSTRateList
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            gstStat: this.gstStat
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((gstRate) => {
              const convertList = {
                gstStat: gstRate.gstStat,
                gstRate: formatDisplayNumber(gstRate.gstRate),
                effDate: formatDisplayDate(gstRate.effDate),
                nativeEffDate: gstRate.effDate
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSaveGSTStat() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: this.newGSTStat ? 'post' : 'put',
            url: this.newGSTStat ? this.menu.createGSTStat : this.menu.updateGSTStat,
            data: this.gstStatForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                if (this.newGSTStat) {
                  this.$router.push({
                    name: 'gstStatDet',
                    params: {
                      gstStat: this.gstStatForm.gstStat
                    }
                  })
                } else {
                  this.fetchGSTStat()
                }
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    checkReview(data) {
      return removeTime(data.nativeEffDate) > removeTime(new Date())
    },
    doNewGSTRate() {
      this.resetMessages()
      this.gstRateForm.gstStat = this.gstStat
      this.gstRateForm.effDate = new Date()
      this.gstRateForm.gstRate = formatDisplayNumber(0.0)
      this.gstRateForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.gstRateForm.createdDate = new Date()
      this.newGSTRate = true
      this.reviewGSTRate = true
      this.reviewGSTRateMode = false
      this.queryGSTRateMode = false
    },
    async doReviewGSTRate(data) {
      this.doFetchGSTRateData(data)
      this.reviewGSTRateMode = true
      this.queryGSTRateMode = false
    },
    async doQueryGSTRate(data) {
      this.doFetchGSTRateData(data)
      this.reviewGSTRateMode = false
      this.queryGSTRateMode = true
    },
    doFetchGSTRateData(data) {
      this.resetMessages()
      const apiURI = this.menu.getGSTRate
      if (apiURI && data) {
        const expand = {
          gstStat: data.gstStat,
          effDate: removeTime(data.nativeEffDate)
        }
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.gstRateForm.gstStat = data.gstRate.gstStat
              this.gstRateForm.effDate = data.gstRate.effDate
              this.gstRateForm.gstRate = formatDisplayNumber(data.gstRate.gstRate)
              this.gstRateForm.createdBy = data.createdBy
              this.gstRateForm.createdDate = data.createdDate
              this.gstRateForm.modifiedBy = data.modifiedBy
              this.gstRateForm.modifiedDate = data.modifiedDate
              this.newGSTRate = false
              this.reviewGSTRate = true
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doSaveGSTRate() {
      this.resetMessages()
      this.$validator.validateAll('gstRateForm').then(async (result) => {
        if (result) {
          const currDate = removeTime(new Date())
          this.gstRateForm.effDate = removeTime(this.gstRateForm.effDate)
          this.gstRateForm.gstRate = removeFormatNumber(this.gstRateForm.gstRate)
          const config = {
            method: this.newGSTRate ? 'post' : 'put',
            url: this.newGSTRate ? this.menu.createGSTRate : this.menu.updateGSTRate,
            data: this.gstRateForm
          }
          if (config.url) {
            let prompt = true
            if (this.gstRateForm.effDate.getTime() < currDate.getTime()) {
              this.promptLabel = 'Effective Date is earlier than Today. Are you sure you want to continue?'
              prompt = await this.$refs.globalPrompt.doPopUp()
            }
            if (prompt) {
              this.$http
                .request(config)
                .then((result) => {
                  const { data } = result
                  this.notify(data)
                  this.fetchGSTRate()
                  this.doClose()
                })
                .catch((err) => {
                  const { data } = err.response
                  if (data) {
                    this.message(data)
                    this.fieldMessage(data)
                  }
                })
            }
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doDelete(data) {
      this.resetMessages()
      const apiURI = this.menu.deleteGSTRate
      if (apiURI && data) {
        this.selected.gstStat = data.gstStat
        this.selected.effDate = removeTime(data.nativeEffDate)
        this.selected.gstRate = data.gstRate
        if (Date.parse(data.nativeEffDate) >= removeTime(Date.now()).getTime()) {
          this.$refs.confirmDelete.doPopUp().then((result) => {
            if (result) {
              this.$http
                .delete(expandURI(apiURI, this.selected))
                .then((result) => {
                  const { data } = result
                  this.notify(data)
                  this.fetchGSTRate()
                })
                .catch((err) => {
                  const { data } = err.response
                  if (data) {
                    this.message(data)
                    this.fieldMessage(data)
                  }
                })
            }
          })
        } else {
          this.$toast.error('Cannot delete GST Rate which is earlier than today')
        }
      }
    },
    doClose() {
      this.resetMessages()
      this.newGSTRate = false
      this.reviewGSTRate = false
      this.queryGSTRateMode = false
      this.reviewGSTRateMode = false
    },
    doCancel() {
      this.$router.push({ name: 'gstStat' })
    }
  },
  computed: {
    newGSTStat() {
      return this.gstStat === 'new'
    },
    menu() {
      return this.$store.state.gstParam.menu
    },
    gstStatMode() {
      return this.$route.params.gstStatMode
    }
  },
  created() {
    if (this.gstStatMode === 'Review') {
      this.reviewMode = true
    } else if (this.gstStatMode === 'Query') {
      this.queryMode = true
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  watch: {
    gstStat(value) {
      this.doInit()
    }
  },
  mixins: [MessageMixin, TableConst.default],
  props: ['gstStat']
}
</script>

<style>
</style>
